<template>
  <div class="sports_rank">
    <div class="myinfo">
      <div class="base">
        <div>
          <div>
            <div v-if="myinfo.organization">{{myinfo.organization}}</div>
            <div>{{myinfo.groupname}}</div>
          </div>
          <div class="myrank">
            <template v-if="+myinfo.rank > 0">第 {{ myinfo.rank }} 名</template>
            <template v-else>暂无排名</template>
          </div>
        </div>
        <div>
          <div>{{myinfo.total}}</div>
          <div>点亮点位</div>
        </div>
      </div>
      <div class="userlist">
        <div v-for="item in myinfo.userlist" class="u-item" :key="item.urid">
          <div>
            <div><img :src="item.avatarurl" alt=""></div>
            <div>
              <span>{{item.isleader==1?'队长：':'队员：'}}</span>
              <span>{{item.name}}</span>
            </div>
          </div>
          <div>点亮：{{item.total}}</div>
        </div>
      </div>
    </div>
    

    <List
      style="color:#FFF;"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getRankList"
    >
      <div class="rank-list">
        <van-collapse v-model="activeNames" v-if="rankList.length">
          <van-collapse-item :name="item.groupid" v-for="item in rankList" :key="item.groupid">
            <template #title>
              <div class="collapse-title">
                <div class="rank_icon">
                  <template v-if="item.rank <= 3">
                    <img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
                    <img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
                    <img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
                  </template>
                  <span v-else>{{ item.rank }}</span>
                </div>
                <div>
                  <div v-if="item.organization">{{item.organization}}</div>
                  <div>{{item.groupname}}</div>                  
                </div>
                
              </div>
            </template>
            <template #value>
              <div class="collapse-value">
                <div>{{item.total}}</div>
                <div>点亮点位</div>
                <div>{{item.datetime|fromunixtime1}}</div>
              </div>
            </template>
            <div class="clist">
              <div v-for="citem in item.userlist" :key="citem.urid" class="u-item">
                <div>
                  <div><img :src="citem.avatarurl" alt=""></div>
                  <div>
                    <span>{{citem.isleader==1?'队长：':'队员：'}}</span>
                    <span>{{citem.name}}</span>
                  </div>
                </div>
                <div>点亮：{{citem.total}}</div>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
        <Empty
          style="background: #fff;min-height: 6rem"
          :style="`border-radius: ${borderRadius}`"
          v-else
          description="暂无数据"
        />
      </div>
    </List>
  </div>
</template>

<style lang="less" scoped>
@import "./index.less";

.filter {
  width: 6.9rem;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .item {
    font-size: 0.3rem;
    padding: 0.12rem 0;
    width: 2rem;
    display: flex;
    justify-content: center;
    border-radius: 0.2rem 0.2rem 0 0;

    &.active {
      background: #fff;
      color: #333;
    }
  }
}
</style>

<script>
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Popup,Collapse, CollapseItem } from "vant";

export default {
  computed: {
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
    borderRadius() {
      if (this.filter) {
        let i = this.filter.findIndex((row) => {
          return row.active == 1;
        });
        if (i == 0) {
          return "0 .2rem .2rem .2rem";
        } else {
          return ".2rem";
        }
      }
    },
  },
  components: {
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    Row,
    Col,
    Popup,
    vanCollapse:Collapse, vanCollapseItem:CollapseItem
  },
  data() {
    return {
      activeNames: [],
      rankList: [],
      loading: false,
      finished: false,
      detail: "",
      page: 1,
      systime: "",
      myinfo: "",
      register_type: "",
      filter: [],
      type: "",
      physical_item_id: 0,
      showVideo: false,
      videoUrl: '',
      animation: 0
    };
  },
  methods: {
    getRankList: function () {
      //如果为空or 0 按照 item_id  rank
      this.$api.activity.groupRank({acid: this.$route.params.acid}).then(res=>{
          if(res.status === 200) {
            this.loading = false;          
            this.myinfo = res.data.my
            this.rankList = res.data.list
            let t = null

            this.rankList.forEach((item, index) => {
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.total*1 == t.total*1 && n.datetime*1 == t.datetime*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })
            this.finished = true;
          }
      })
    },
    init: function () {
    },
  },
  mounted() {
    this.init();
    // this.getRankList();
  },
};
</script>
